var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visiable)?_c('div',{staticClass:"mask",style:(_vm.customStyle),on:{"click":_vm.onClickMask,"touchmove":function($event){$event.preventDefault();}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }